import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import type { AppStateType } from '../../../../../reducers/appstate'
import type {
  DispatchPropsType,
  PropsType
} from './LinkFacebook'
import LinkFacebook from './LinkFacebook'
import { PROVIDERS } from '../../../../../flowTypes'
import { toggleFacebookConnection } from '../../../../../actions/userActions'

const mapStateToProps = (state: AppStateType): PropsType => {
  return {
    isConnected: (state.user.providers || []).includes(PROVIDERS.facebook),
    linkAccountRequestInProgress: state.linkAccountRequestInProgress,
    isLoading: state.linkAccountRequestInProgress && (state.linkAccountRequestProvider === PROVIDERS.facebook)
  } as PropsType
}

const mapDispatchToProps = (dispatch: Dispatch<any>): DispatchPropsType => {
  return {
    toggleFacebookConnection: (isConnected: boolean): void => dispatch(toggleFacebookConnection(isConnected))
  } as DispatchPropsType
}

export default connect(mapStateToProps, mapDispatchToProps)(LinkFacebook)
